import lazyLoading from './lazyLoading'

export default {
  name: 'PotentialCustomerReport',
  path: '/reports/pc_report/:customerId/:reportPermalink',
  component: lazyLoading('reports/potentialCustomerReport', true),
  meta: {
    label: 'Potential Customer Report'
  },
  props: true
}
